module.exports = "/assets/data/c5977d35e33a501d69736ae428a607a7-YO41.data.json";